import * as React from 'react';
import { Menu, Dropdown } from 'antd';

import MyIcon from './Icon';
const css = require('./index.scss');

export interface IIconProps {
    menuItem: any[]; // menu 元素
    layout?: ('row' | 'column'); // 图标的排列方向 默认 column
    trigger?: ('click' | 'hover' | 'contextMenu')[]; // 出现menu的方式
    menuOnClick?: (v: any) => void; // 点击menu后的回调函数
    menuItemWidth?: number; // 菜单栏的宽度
    placement?: 'topLeft' | 'topCenter' | 'topRight' | 'bottomLeft' | 'bottomCenter' | 'bottomRight'; // 菜单栏显示的位置
    spotIcon?: any; // 按钮图标的样式 className
    spotBox?: any; // 按钮图标外层盒子的样式 className
    
}

export default function SearchGroup(props: IIconProps) {

    const classNameSpotIcon = () => {
        return props.spotIcon ? `${css.spotIcon} ${props.spotIcon}` : css.spotIcon;
    };

    const classNameSpotBox = () => {
        return props.spotBox ? `${css.spotBox} ${props.spotBox}` : css.spotBox;
    };

    const [visible, setVisible] = React.useState(false);
    const onVisibleChangeHandler = (v: boolean) => {
        setVisible(v);
    };
    const menuHandler = (v: any) => {
        if (props.menuOnClick) {
            props.menuOnClick(v);
            setVisible(false);
        }
    };

    const menu = (
        <Menu style={{width: `${props.menuItemWidth || '160px'}`}}>
            {
                props.menuItem.map((v, i) => {
                    return  <Menu.Item key={i} onClick={() => menuHandler(v)} className={css.menuItem}>
                                {v}
                            </Menu.Item>;
                })
            }
        </Menu>
    );
    const placement = (props.placement || 'bottomRight') as ('topLeft' | 'topCenter' | 'topRight' | 'bottomLeft' | 'bottomCenter' | 'bottomRight');
    return (
        <div className={visible ? `${classNameSpotBox()} ${css.activeBg}` : `${classNameSpotBox()}`}>
            <Dropdown overlay={menu} visible={visible} trigger={props.trigger || ['click']} placement={placement} onVisibleChange={onVisibleChangeHandler}>
                <div>
                    {
                        props.layout === 'row' ?
                            <MyIcon className={classNameSpotIcon()} src={require('./Icon/rowSpot.svg')}/> :
                        (props.layout === 'column' || !props.layout) ?
                            <MyIcon className={classNameSpotIcon()} src={require('./Icon/spot.svg')}/> :
                        ''
                    }
                </div>
            </Dropdown>
        </div>  
    );
}


// WEBPACK FOOTER //
// ./src/display/components/ButtonGroup/index.tsx